// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"df775830","736":"1dc33170"}[chunkId] + ".chunk.js";
};